import { IAttrValue } from "@multiweb/types/contracts";
import { Enum } from "../../../../../OW.Remoting/Remoting/DataTypes/Enums";
import { Column } from "../../Columns/Column";
import { ItemTemplate } from "../ItemTemplate";

export class FlagTemplates extends ItemTemplate {
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement, forGrouping?: boolean): Promise<void> {
        const content = await this._createFlagElement(dataSet, this.parentColumn, forGrouping);
        item.innerHTML = "";
        item.appendChild(content);
    }

    private async _createFlagElement(dataSet: IAttrValue[], column: Column, forGrouping: boolean): Promise<HTMLDivElement> {
        const innerElement = document.createElement("div");
        const flagElement = document.createElement("div");
        const spanElement = document.createElement("span");
        let flagColor = await this._getJoinData(dataSet, column);
        flagColor = flagColor.trim();

        if (flagColor.length > 0)
            flagElement.classList.add("flag", flagColor);

        // Pro potřeby automatických testů, aby se u flagcolumnu vždy přidala třída fNone podle které jde ověřit že není vybrána žádná barva
        if (!dataSet || !dataSet[0])
            flagElement.classList.add("flag", "fNone");

        innerElement.classList.add("flags");

        spanElement.appendChild(flagElement);
        innerElement.appendChild(spanElement);

        // V případě groupování přidáme ke kolečku i text s lokalizací
        if (forGrouping && dataSet.length > 0 && dataSet[0] instanceof Enum) {
            const descriptionElement = document.createElement("span");
            const flagText = await (dataSet[0] as Enum).getLocalizedName();
            descriptionElement.innerText = flagText;
            flagElement.classList.add("flags-group");
            innerElement.classList.add("flags-group");
            innerElement.appendChild(descriptionElement);
        }

        return innerElement;
    }
}
